/**
 * Chat Initial State
 * Default state configuration for the chat Redux slice
 */

import { ChatState } from './chatTypes';

/**
 * Initial state for the chat slice
 */
export const initialChatState: ChatState = {
  messages: [],
  conversations: [],
  loading: false,
  loadingHistory: false,
  loadingMessages: false,
  error: null,
  conversationStates: {},
  currentConversationId: undefined,
  pagination: {
    hasMore: true,
    lastTimestamp: undefined,
    loadingMore: false,
  },
}; 